<template>
<div class="mt_140">

        <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
        <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

        <div class="container">
        <div class="row">
        <div class="col-md-12">

          <!-- row -->
          <div class="row">

              <!-- coluna 2 -->
              <div class="col-md-2">
                <ccMenuConta :num=6></ccMenuConta>
              </div">
              <!-- fim coluna 2 -->

              <!-- coluna 10 -->
              <div class="col-md-10 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                <div class="card">
                <div class="card-body">

                  <div v-show="box_principal">

                        <!-- TEXTO -->
                        <section class="mb-3">
                          <div class="row mb-4">
                            <div class="col-12 text_12 text_cinza" style="text-align: justify;">
                              <p class="text_18">Jogo pode não ser divertido!</p>

                              <p> 
                                Pode soar contraditório, mas é uma realidade complexa: a essência de um jogo é oferecer entretenimento e diversão, mas nem sempre é assim que as coisas se desenrolam.
                                Há uma miríade de elementos que podem afetar a experiência lúdica de um indivíduo, transformando o que deveria ser uma fonte de alegria em algo potencialmente problemático.
                              </p>
                              <p>  
                                É fundamental reconhecer quando o jogo deixa de ser um passatempo saudável e começa a se tornar uma preocupação. Se você perceber que está perdendo o controle, que sua rotina 
                                e bem-estar estão sendo afetados, o mais sensato é fazer uma pausa. Admitir que pode haver um problema é o primeiro passo para enfrentá-lo.
                              </p>
                              <p>
                                Neste momento, lembre-se de que você não está sozinho. Estamos aqui para oferecer apoio e orientação sobre como lidar com o vício em jogos. Nossa equipe está pronta para ajudá-lo 
                                a recuperar o equilíbrio e retomar o controle da situação. O importante é buscar ajuda e começar a jornada para um relacionamento mais saudável com os jogos.
                              </p>

                            </div>
                          </div>
                        </section>

                        <!-- PERIODO -->
                        <section class="mt-3 mb-3">
                          <div class="row mb-3">
                            <div class="col-10 offset-1">

                              <div class="row">
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="24h">
                                      <label class="form-check-label" for="inlineRadio1">24 Horas</label>
                                    </div>
                                </div>
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="48h">
                                      <label class="form-check-label" for="inlineRadio2">48 Horas</label>
                                    </div>
                                </div>
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="72h">
                                      <label class="form-check-label" for="inlineRadio2">72 Horas</label>
                                    </div>
                                </div>
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="1mes">
                                      <label class="form-check-label" for="inlineRadio3">1 Mês</label>
                                    </div>
                                </div>
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="2mes">
                                      <label class="form-check-label" for="inlineRadio3">2 Meses</label>
                                    </div>
                                </div>
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="3mes">
                                      <label class="form-check-label" for="inlineRadio3">3 Meses</label>
                                    </div>
                                </div>
                                <div class="col-4 text_12 text_cinza mb-4">
                                    <div class="form-check form-check-inline">
                                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="bloqueio_tipo" value="6mes">
                                      <label class="form-check-label" for="inlineRadio3">6 Meses</label>
                                    </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </section>

                        <!-- BOTOES -->
                        <section class="mb-4">
                          <div class="row mb-3">
                            <div class="col-6 offset-3 text_12 text_bold text_cinza">
                              <button class="btn btn-danger btn-sm mt-3" @click="pergunte_se_pode()">
                                SUSPENDER MINHA CONTA TEMPORARIAMENTE POR {{this.bloqueio_tipo}}
                              </button>
                            </div>
                          </div>
                        </section>

                  </div>

                  <div v-show="box_alert">
                    <div class="text_laranja">
                      <div class="text-center text_18"> <b>Atenção!</b> </div>
                      <div class="mb-4 text-center"> <b>{{box_alert_text}}</b> </div>
                      <div class="row">
                      <div class="col-6">
                        <button type="button" class="btn btn-outline-success w-100 mb-3" data-bs-dismiss="modal" @click="continuar(true)">SIM</button>
                      </div>
                      <div class="col-6">
                        <button type="button" class="btn btn-outline-danger w-100" data-bs-dismiss="modal" @click="continuar(false)">NÃO</button>
                      </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="box_bloqueado_informacao" style="margin-top:100">
                    <div class="modal-body text_laranja">
                      <div class="text-center text_18 mb-4"> <b>Você está suspenso, por {{bloqueio_tipo}}.</b> </div>
                      <div class="mb-4 text-center"> Início: {{user_aux.bloqueio_inicio}} </div>
                      <div class="mb-4 text-center"> Fim: {{user_aux.bloqueio_expira}} </div>
                    </div>
                  </div>

                </div>
                </div>

              </div>
              <!-- fim coluna 10 -->

          </div>
          <!-- fim row -->

      </div>
      </div>
      </div>

    <ccFooter></ccFooter>

</div>
</template>


<script>

import axios from 'axios';
import {TheMask} from 'vue-the-mask';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'AUTO EXCLUSÃO',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      user_aux: {},
      loading: false,
      errors: [],

      //variaveis
      box_principal: false,
      box_alert: false,
      box_alert_text: null,
      box_bloqueado_informacao: false,

      bloqueio_tipo: null,
    }
  },

  components: {ccMenu, TheMask, ccMenuConta, ccLoading, ccFooter},

  created(){
    document.title = 'Minha Conta: Auto Exclusão - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} }else{ this.user = a }

    this.get_user_completo()
  },

  methods: {

    get_user_completo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'user/completo', header)
      .then(response => {
        this.user_aux = response.data.resp

        this.bloqueio_tipo = this.user_aux.bloqueio_tipo

        this.box_principal = false
        this.box_alert = false
        this.box_bloqueado_informacao = false

        if(this.user_aux.bloqueio_tipo == null || this.user_aux.bloqueio_tipo == 'null'){
          this.box_principal = true
        }
        else{
          this.box_bloqueado_informacao = true
        }

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
        alert(e)
        // this.expluse_para_login()
      });
    },

    async suspender() {
        this.loading = true;
        var body ={
          bloqueio_tipo: this.bloqueio_tipo,
        }

        var header = { 'headers': { 'x-access-token': this.user.access_token, } };
        axios.post(this.base_url_api+'conta/suspender', body, header)
        .then(response => {
            this.box_alert = true
            this.box_alert_text = response.data.status=='success'?'Conta suspensa com sucesso! ':response.data.status
            this.loading = false;

            this.get_user_completo()
        })
        .catch(e => {
            this.alerta_texto = e.message +':  '+ e.response.data.message;
            this.loading = false;
        });
    },

    pergunte_se_pode(){
      this.box_principal = false
      this.box_alert_text = "TEM CERTEZA QUE DESEJA FAZER ISSO? SUA CONTA SERÁ BLOQUEADA ATÉ EXPIRAR O PERÍODO DESEJADO!"
      this.box_alert = true
    },

    continuar(n){
      if(n == true){
        this.suspender()
      } else {
        this.box_alert = false
        this.box_principal = true
      }
    },

  }

}

</script>

<style scoped>
  .card{
    background: #FFFFFF08 0% 0% no-repeat padding-box;
    color:#fff;
  }

  input.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  input.form-control.disabled{
    background-color: #21232d;
    opacity: 0.5;
  }

  select.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/conta/auto_exclusao.vue